import React, { Component } from 'react';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';


class SystemReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  };


  render() {
    return (<Col>
      <div style={{ marginTop: 10, marginBottom: 20 }}>
        <div className="card__title">
          <h5 className="bold-text">Revisión del Sistema</h5>
        </div>
      </div>
      <div className="form">
        {this.props.ailments.map((ailment, index) => {
          return (<div key={index} className="form__form-group" style={{ width: '100%', marginRight: 20, display: 'flex' }}>
            <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>{ailment.ailment}</span>
            <div className="form__form-group-field">
              <textarea
                name={`comment-${ailment.ailment}`}
                defaultValue={ailment.commentary}
                onChange={(e) => { this.props.handlerCommentsSystemReview(e.target.value, index) }}
              >
              </textarea>
            </div>
          </div>)
        })}
      </div>
    </Col>)
  }
}

export default reduxForm({
  form: `system-review-form`, // a unique identifier for this form
})(withTranslation('common')(SystemReview));